import React from 'react';
import { MailIcon, Globe2Icon, InstagramIcon } from 'lucide-react';
export function Footer() {
  return <footer className="bg-[#0A0A0A] px-5 py-14 text-center" data-id="element-69" data-mp="3gfivmltl4hfp">
      <div className="mx-auto max-w-4xl" data-id="element-70" data-mp="3gh3rqfvjs8fo">
        <p className="font-display text-3xl font-bold uppercase tracking-wide text-[#d4af37]" data-id="element-71" data-mp="32onll67cnuaj">
          Rugby Ready™
        </p>
        <p className="mt-3 font-bold text-white" data-id="element-72" data-mp="36pzebklisvmy">
          The #1 planning system for rugby coaches worldwide.
        </p>
        <p className="mt-2 text-sm italic text-[#B0B0C0]" data-id="element-73" data-mp="3ud7i1y3avwmv">
          Because coaching shouldn’t cost you every evening of the week.
        </p>
        <div className="mx-auto mt-8 flex max-w-xl flex-wrap justify-center gap-x-6 gap-y-3 border-y border-[#d4af37]/20 py-6 text-sm font-semibold text-[#B0B0C0]" data-id="element-74" data-mp="3lf5b71wvy9ro">
          <a className="flex items-center gap-2 hover:text-white" href="mailto:support@rugbyready.com" data-id="element-75" data-mp="29z6ucbvgujfw">
            <MailIcon className="h-4 w-4 text-[#d4af37]" data-id="element-76" data-mp="2ey09e8qeiii6" />
            support@rugbyready.com
          </a>
          <a className="flex items-center gap-2 hover:text-white" href="https://instagram.com/rugbyready" data-id="element-77" data-mp="3l90m9rokaqx5">
            <InstagramIcon className="h-4 w-4 text-[#d4af37]" data-id="element-78" data-mp="3gaz7hiy65drh" />
            @rugbyready
          </a>
          <a className="flex items-center gap-2 hover:text-white" href="https://rugbyready.com" data-id="element-79" data-mp="3v7zy1j4mj2od">
            <Globe2Icon className="h-4 w-4 text-[#d4af37]" data-id="element-80" data-mp="3q8dkf8kvvkf1" />
            rugbyready.com
          </a>
        </div>
        <p className="mt-8 text-[10px] font-bold uppercase tracking-widest text-[#5A5A66]" data-id="element-81" data-mp="81ywqhwtbw3g">
          © Rugby Ready™ 2026 — All rights reserved.
        </p>
      </div>
    </footer>;
}